import { defineComponent } from 'vue'
import type { ExtractPropTypes, PropType } from 'vue'


export const pagetableColumngroupProps = () => ({
  head: String,
  headAlign: String as PropType<'left' | 'right' | 'center'>,
})

export type PagetableColumngroupProps = Partial<ExtractPropTypes<ReturnType<typeof pagetableColumngroupProps>>>

export default defineComponent({
  name: 'OPagetableColumngroup',
  inheritAttrs: false,
  props: pagetableColumngroupProps(),
  setup(props, { slots, attrs, emit, expose }) {
    return () => null
  },
})
